var registeredThemes = {};
export function registerTheme(themeName, themeConfig) {
    registeredThemes[themeName] = themeConfig;
}
export function getRegisteredTheme(themeName) {
    return registeredThemes[themeName];
}
